import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import { Icons, Images } from '../../assets';
import { Toast } from '../../service/toast';
import Button from '../../component/Button';
import { FormProvider, useForm } from 'react-hook-form';
import Exported from '../../service/endpoints';
import request from '../../service';
import InputBox from '../../component/InputBox';

const DeleteAccount = () => {
  const [email, setEmail] = useState('');
  const formMethods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    formState: { errors },
    register,
    trigger,
    setValue,
    watch
  } = formMethods

  const onSubmit = (data) => {
    let url = Exported.Endpoints.deleteAccount;
    let paramsObj = {
      email: data.email,
    }

    request({
      url: url,
      method: Exported.APIMethods.POST,
      data: { ...paramsObj }
    }).then((res) => {
      if (res?.data?.status) {
        const response = res?.data?.data
        console.log(res)
        setValue("email", '')
        Toast({
          type: "success",
          message: "Request Send Successfully!...",
        });
      }
    }).catch((err) => {
      Toast({
        type: "error",
        message: err?.response?.data?.message || "Unable to process the request!..",
      });
    });
  }


  return (
    <div className='flex items-center justify-center w-[100%] h-[100%]'>
      <div className={`${classes.deletePage}`}>
        <div className={classes.logoContainer}>
          <img src={Icons.kgLogo} className={classes.appLogo} />
        </div>
        <div className={classes.DeleteHeader}>Deleting Account</div>
        <div className={classes.DeleteDescription}>Deleting your account will remove all your information from our databases. This Cannot be undone.</div>

        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.deleteInputContainer}>

              <div>
                <div className={classes.deleteInput}>To Confirm this, enter "Email Address"</div>
                <InputBox
                  // label={"Email"}
                  className="w-[100%]"
                  name={"email"}
                  value={email}
                  authInput
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  error={errors.email}
                  messages={{
                    required: "Email is required",
                    pattern: "Invalid email address",
                  }}
                />
              </div>
              <Button
                text={"Delete Account"}
                className={"ml-3 px-3 "}
                smallBtn
                style={{ height: "56px", padding: "0px 30px", background: '#FC0000', border: 'none' }}
              />
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}

export default DeleteAccount;
